/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
import { AccountClient, RESEND_USERS_ACTIVATION } from '@nile/graphql';
import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { FormattedMessage, useIntl } from 'react-intl';
import { getTranslatedText, toast, ERROR_CODES } from '@nile/components';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';
import { Tooltip } from 'react-clone-tippy';
import { Button, Link } from '@superops/ui-design-system';
import LoadingSpinner from '@nile/components/src/Svg/AnimatedSvg/LoadingSpinner.svg';

const ResendWrapper = styled.div`
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
  pointer-events: ${(props) => (props.disabled ? 'none' : '1')};
`;

const ButtonContainer = styled.div`
  .Superops-Button {
    width: 100%;
    .Superops-Button__Text {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

const LoaderWrapper = styled.div`
  svg {
    height: 16px;
    width: 16px;
    circle {
      stroke: #00000080;
    }
    g {
      circle {
        stroke: #d0d0d0;
      }
    }
  }
  .status {
    width: calc(100% - 21px);
  }
`;

export default function ResendInvitationButton(props) {
  const { user, showError, linkType, showWarning } = props;
  if (!user) {
    return null;
  }
  const { activated, activationMailStatus, activationMailFailureReason } = user;
  const [invitationSentLoading, setInvitationSentLoading] = useState(false);

  const intl = useIntl();

  const [resendInvitation, { loading }] = useMutation(RESEND_USERS_ACTIVATION, {
    client: AccountClient,
    variables: {
      input: [user?.userId]
    },
    onCompleted({ resendUsersActivationMail }) {
      if (resendUsersActivationMail) {
        toast(
          'success',
          getTranslatedText(intl, 'admin.employee.mailSentSuccesss.success')
        );
        if (
          resendUsersActivationMail?.[0]?.activationMailStatus === 'SENDING'
        ) {
          setInvitationSentLoading(true);
        }
        if (props.onSuccess)
          props.onSuccess({ data: resendUsersActivationMail?.[0] });
      }
    }
  });

  if (activated) {
    return null;
  }

  if (activationMailStatus === 'SENDING' || invitationSentLoading) {
    return (
      <LoaderWrapper className="fx actr">
        <LoadingSpinner />{' '}
        <div className="status ellipsis ml-5">
          <FormattedMessage id="app.common.email.status.sending" />
        </div>
      </LoaderWrapper>
    );
  }

  if (!linkType && activationMailStatus === 'NOT_SENT') {
    return (
      <ButtonContainer
        className="no-scroll"
        title={getTranslatedText(intl, 'client.users.sendInvitation.label')}
      >
        <Button
          loading={loading}
          onClick={resendInvitation}
          icon={<SVGIcon name="SendWhite" />}
        >
          <div className="nowrap ellipsis full-width">
            <FormattedMessage id="client.users.sendInvitation.label" />
          </div>
        </Button>
      </ButtonContainer>
    );
  }

  let errorMessage = null;
  if (activationMailFailureReason?.errorCode) {
    errorMessage =
      ERROR_CODES[activationMailFailureReason?.errorCode] ||
      activationMailFailureReason?.message ||
      'app.common.email.not.delivered';
  }

  return (
    <div className="fx actr">
      {showError && errorMessage && (
        <Tooltip
          html={<div>{getTranslatedText(intl, errorMessage)}</div>}
          delay={400}
          duration={250}
          position="bottom"
          inertia
          trigger="mouseenter"
          animation="shift"
          animateFill={false}
        >
          <span className="fx actr mr10">
            <SVGIcon name="About" color="#FF5050" />
          </span>
        </Tooltip>
      )}
      {!showError && showWarning}
      <ResendWrapper className="flex center" disabled={loading}>
        <Link removeUnderline onClick={resendInvitation}>
          <FormattedMessage
            id={
              linkType && activationMailStatus === 'NOT_SENT'
                ? 'client.users.sendInvitation.label'
                : 'client.users.resendInvitation.label'
            }
          />
        </Link>
      </ResendWrapper>
    </div>
  );
}
